import SubmitAWSPortOpeningRequestRule from './SubmitAWSPortOpeningRequestRule';

export default class SubmitAWSPortOpeningRequest {

	accountId!: number;

	secondaryAccountId: number;

	portOpeningRules!: SubmitAWSPortOpeningRequestRule[];

	cartaId!: string;

	appEndorserId!: string;

	type!: string;

	direction!: string;

	environment: string;

	contactId!: string;

	emergency!: boolean;

	businessJustification!: string;

	comments!: string;

	customerCoordination!: boolean;

	approverId!: string;

	secondaryApproverId!: string; 

	AWSPortOpeningRequestId!: number;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}